import jQuery from 'jquery';

window.$ = window.jQuery = jQuery;

require('select2');
